import { memo, useEffect } from "react";
import { PropTypes } from "prop-types";
import { FormattedMessage } from "react-intl";
import AmountContainer from "app/pages/.shared/AmountContainer.jsx";
import { sendTagDepositNoteViewed } from "app/utils/analytics";

import "./PayNowNote.scss";
import PaymentModesTooltipContainer from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentModes/PaymentModesTooltipContainer";
import InfoPopover from "app/components/ui/InfoPopover/InfoPopover";

const PayNowNote = ({
	total,
	depositPercentage,
	availablePaymentMethods = [],
	displayAmountSuffix = true,
}) => {
	useEffect(() => {
		sendTagDepositNoteViewed();
	}, []);

	if (!depositPercentage) {
		return false;
	}

	const payNow = Math.ceil((total * depositPercentage) / 100);

	const note = (
		<FormattedMessage
			id="my.bookings.pay.now.note.amount"
			tagName="span"
			values={{
				amount: (
					<AmountContainer
						amount={payNow}
						suffix={
							displayAmountSuffix && (
								<FormattedMessage id="general.amount.per.person.suffix.label.short" />
							)
						}
					/>
				),
			}}
		/>
	);

	return (
		<div className="pay-now-note" data-testid="pay-now-note">
			{note}
			<InfoPopover>
				<PaymentModesTooltipContainer paymentModes={availablePaymentMethods} />
			</InfoPopover>
		</div>
	);
};

PayNowNote.propTypes = {
	total: PropTypes.number,
	depositPercentage: PropTypes.number,
	availablePaymentMethods: PropTypes.array,
	displayAmountSuffix: PropTypes.bool,
};

export default memo(PayNowNote);
